document.addEventListener('DOMContentLoaded', function() {
  /* --- 価格チップにリンク＋アロー追加 --- */
  var chips = document.querySelectorAll('.yebisu-price-chip');
  chips.forEach(function(chip) {
    var text = chip.innerText;
    var url = '';
    if (text.indexOf('\u30D1\u30FC\u30C4') !== -1) url = '/collections/partscleaner';
    else if (text.indexOf('\u30AA\u30A4\u30EB\u30D5\u30A3\u30EB\u30BF\u30FC') !== -1) url = '/collections/oilfilter';
    else if (text.indexOf('\u30B9\u30EA\u30F3\u30B0\u30D9\u30EB\u30C8') !== -1) url = '/collections/slingbelt';
    if (url) {
      chip.style.cursor = 'pointer';
      chip.style.position = 'relative';
      var arrow = document.createElement('span');
      arrow.textContent = '\u25B6';
      arrow.style.cssText = 'position:absolute;right:6px;top:50%;transform:translateY(-50%);font-size:10px;color:#E87A00;opacity:0.7;';
      chip.appendChild(arrow);
      chip.addEventListener('click', function() {
        window.location.href = url;
      });
    }
  });

  /* --- CTAボタンにアロー追加 --- */
  var cta1 = document.querySelector('.yebisu-cta-primary');
  if (cta1 && cta1.textContent.indexOf('\u25B6') === -1) {
    cta1.insertAdjacentText('beforeend', ' \u25B6');
  }
  var cta2 = document.querySelector('.yebisu-cta-secondary');
  if (cta2 && cta2.textContent.indexOf('\u25B6') === -1) {
    cta2.insertAdjacentText('beforeend', ' \u25B6');
  }

  /* --- ヘッダー会員登録ボタンにアロー追加 --- */
  var headerBtns = document.querySelectorAll('header a[href*="/account/register"], .header a[href*="/account/register"]');
  headerBtns.forEach(function(btn) {
    if (btn.textContent.indexOf('\u25B6') === -1) {
      btn.insertAdjacentText('beforeend', ' \u25B6');
    }
  });

  /* --- グレー文字を黒に変更（シングル・ダブル両方対応） --- */
  var colorSelectors = [
    '.yebisu-hero_sub', '.yebisu-hero__sub',
    '.yebisu-price-chip_label', '.yebisu-price-chip__label',
    '.yebisu-price-chip_compare', '.yebisu-price-chip__compare',
    '.yebisu-price-chip_unit', '.yebisu-price-chip__unit',
    '.yebisu-trust-card_label', '.yebisu-trust-card__label'
  ];
  colorSelectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(el) {
      el.style.setProperty('color', '#333', 'important');
    });
  });

  /* --- お知らせ「すべてを表示する」を変更 --- */
  var newsSection = document.getElementById('shopify-section-template--17951157911646__featured_blog_adhkdD');
  if (newsSection) {
    newsSection.querySelectorAll('.blog__button.button, a.button').forEach(function(btn) {
      if (btn.textContent.indexOf('\u3059\u3079\u3066') !== -1) {
        btn.textContent = '\u3059\u3079\u3066\u306E\u304A\u77E5\u3089\u305B\u3092\u898B\u308B \u25B6';
      }
    });
  }

  /* --- ブログ「すべてを表示する」を変更 --- */
  var blogSection = document.getElementById('shopify-section-template--17951157911646__featured_blog_xNqaxh');
  if (blogSection) {
    blogSection.querySelectorAll('.blog__button.button, a.button').forEach(function(btn) {
      if (btn.textContent.indexOf('\u3059\u3079\u3066') !== -1) {
        btn.textContent = '\u3059\u3079\u3066\u306E\u8A18\u4E8B\u3092\u898B\u308B \u25B6';
      }
    });
  }

  /* --- お知らせ・ブログのボタンを楕円に＋外枠削除（改良版） --- */

  // Step 1: ::after 擬似要素を無効化するスタイルを注入
  (function() {
    var style = document.createElement('style');
    style.textContent = 
      '#shopify-section-template--17951157911646__featured_blog_adhkdD .blog__button.button::after,' +
      '#shopify-section-template--17951157911646__featured_blog_xNqaxh .blog__button.button::after,' +
      '#shopify-section-template--17951157911646__featured_blog_adhkdD a.button::after,' +
      '#shopify-section-template--17951157911646__featured_blog_xNqaxh a.button::after {' +
      '  box-shadow: none !important;' +
      '  content: "" !important;' +
      '  border: none !important;' +
      '  outline: none !important;' +
      '}' +
      '#shopify-section-template--17951157911646__featured_blog_adhkdD .blog__view-all,' +
      '#shopify-section-template--17951157911646__featured_blog_xNqaxh .blog__view-all {' +
      '  border: none !important;' +
      '  outline: none !important;' +
      '  box-shadow: none !important;' +
      '  background: transparent !important;' +
      '}';
    document.head.appendChild(style);
  })();

  // Step 2: ボタン本体の楕円化 + 親・祖父要素の枠削除
  document.querySelectorAll('.blog__button.button, a.button').forEach(function(btn) {
    if (btn.textContent.indexOf('\u3059\u3079\u3066') !== -1) {
      btn.style.setProperty('border-radius', '9999px', 'important');
      btn.style.setProperty('overflow', 'hidden', 'important');

      // 親要素の枠削除
      var parent = btn.parentElement;
      if (parent) {
        parent.style.setProperty('border', 'none', 'important');
        parent.style.setProperty('outline', 'none', 'important');
        parent.style.setProperty('box-shadow', 'none', 'important');
        parent.style.setProperty('background', 'transparent', 'important');
      }
      // 祖父要素の枠も削除
      var grandparent = parent ? parent.parentElement : null;
      if (grandparent) {
        grandparent.style.setProperty('border', 'none', 'important');
        grandparent.style.setProperty('outline', 'none', 'important');
        grandparent.style.setProperty('box-shadow', 'none', 'important');
        grandparent.style.setProperty('background', 'transparent', 'important');
      }
    }
  });

  /* --- 「無料で会員登録する」にアロー追加 --- */
  document.querySelectorAll('a, button').forEach(function(btn) {
    if (btn.textContent.trim() === '\u7121\u6599\u3067\u4F1A\u54E1\u767B\u9332\u3059\u308B') {
      btn.textContent = '\u7121\u6599\u3067\u4F1A\u54E1\u767B\u9332\u3059\u308B \u25B6';
    }
  });

  /* --- 全ページの「→」を「▶」に一括変換 --- */
  var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    var node = walker.currentNode;
    if (node.textContent.includes('\u2192') && node.textContent.trim().endsWith('\u2192')) {
      node.textContent = node.textContent.replace(/\u2192/g, '\u25B6');
    }
  }
});